export const homePageSliderData = [
  {
    href: "/products/id",
    img: "/img/slider.png",
  },
  {
    href: "/listing",
    img: "/img/slider1.png",
  },
  {
    href: "/listing",
    img: "/img/slider1.png",
  },
  {
    href: "/listing",
    img: "/img/slider.png",
  },
];

export const homePageRestaurantsData = [
  {
    href: "/detail/:id",
    img: "/img/restaurant.png",
    name: "SubWay",
    type: "Healthy Food • Pure veg",
    ratings: "4.1",
    perPerson: " 50 FOR TWO",
  },
  {
    href: "/detail/:id",
    img: "/img/restaurant.png",
    name: "SubWay",
    type: "Healthy Food • Pure veg",
    ratings: "4.1",
    perPerson: " 50 FOR TWO",
  },
  {
    href: "/detail/:id",
    img: "/img/restaurant.png",
    name: "SubWay",
    type: "Healthy Food • Pure veg",
    ratings: "4.1",
    perPerson: " 50 FOR TWO",
  },
  {
    href: "/detail/:id",
    img: "/img/restaurant.png",
    name: "SubWay",
    type: "Healthy Food • Pure veg",
    ratings: "4.1",
    perPerson: " 50 FOR TWO",
  },
  {
    href: "/detail/:id",
    img: "/img/restaurant.png",
    name: "SubWay",
    type: "Healthy Food • Pure veg",
    ratings: "4.1",
    perPerson: " 50 FOR TWO",
  },
];
